export enum BillingsPlanEntryTaxiDriverRecalculateContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculateBonusContributionOther = {
  type: BillingsPlanEntryTaxiDriverRecalculateContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionBeingLate =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionOther = {
  type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverRecalculateBonusContribution =
  | BillingsPlanEntryTaxiDriverRecalculateBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverRecalculateBonusContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculatePenaltyContribution =
  | BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverRecalculateContribution =
  | BillingsPlanEntryTaxiDriverRecalculateBonusContribution
  | BillingsPlanEntryTaxiDriverRecalculatePenaltyContribution
  | BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationFleetPartner =
  {
    name: string;
  };

export type BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverUser =
  {
    firstName: string;
    lastName: string;
  };

export type BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverStartingAddress =
  {
    displayName: string;
  };

export type BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriver =
  {
    user: BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverUser;
    startingAddress: BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverStartingAddress;
  };

export type BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociation =
  {
    driver: BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriver;
    fleetPartner: BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationFleetPartner | null;
  };

export type BillingsPlanEntryTaxiDriverRecalculateContract = {
  model: string;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociation;
  description: string;
};

export type BillingsPlanEntryTaxiDriverRecalculateBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrderTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrderTransportingOrder =
  {
    cargoOrder: BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrderTransportingOrderCargoOrder;
  };

export type BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrder = {
  transportingOrder: BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrderTransportingOrder;
};

export type BillingsPlanEntryTaxiDriverRecalculatePlanEntry = {
  humanId: number;
  solvedOrders: BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrder[];
};

type BillingsPlanEntryTaxiDriverRecalculate = {
  contract: BillingsPlanEntryTaxiDriverRecalculateContract;
  billingNodes: BillingsPlanEntryTaxiDriverRecalculateBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverRecalculateContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntry: BillingsPlanEntryTaxiDriverRecalculatePlanEntry;
  date: Date;
  passengers: string[];
  rateForDistance: number;
  correctedContractModel: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
};

export default BillingsPlanEntryTaxiDriverRecalculate;
